import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-progress-tracker-1-6-0{padding-right:18px;overflow:hidden;list-style-type:none}.hcr-progress-tracker-1-6-0,.hcr-progress-tracker__item-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;height:36px}.hcr-progress-tracker__item-1-6-0{position:relative;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;min-width:60px;padding-right:6px;padding-left:24px;border:1px solid #73d700;border-right:0;background:#fff;color:#73d700;font-weight:400;line-height:34px;text-decoration:none}@media (min-width:600px){.hcr-progress-tracker__item-1-6-0{-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;min-width:145px}}.hcr-progress-tracker__item-1-6-0:first-child{border-radius:5px 0 0 5px}.hcr-progress-tracker__item-1-6-0:after,.hcr-progress-tracker__item-1-6-0:before{position:absolute;top:50%;left:100%;width:0;height:0;border:solid transparent;content:\"\";z-index:1}.hcr-progress-tracker__item-1-6-0:after{margin-top:-17px;border-width:17px;border-left-color:#fff}.hcr-progress-tracker__item-1-6-0:before{margin-top:-18px;border-width:18px;border-left-color:#73d700}.hcr-progress-tracker__item--active-1-6-0{background:#73d700;color:#fff}.hcr-progress-tracker__item--active-1-6-0:after{border-left-color:#73d700}.hcr-progress-tracker__item--active-1-6-0:before{border-left-color:#fff}.hcr-progress-tracker__number-1-6-0{margin-right:.25em}@media (min-width:600px){.hcr-progress-tracker__number-1-6-0:after{content:\".\"}}.hcr-progress-tracker__text-1-6-0{display:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@media (min-width:600px){.hcr-progress-tracker__text-1-6-0{display:block}}",
map:{"hcr-progress-tracker":"hcr-progress-tracker-1-6-0","hcr-progress-tracker__item":"hcr-progress-tracker__item-1-6-0","hcr-progress-tracker__item--active":"hcr-progress-tracker__item--active-1-6-0","hcr-progress-tracker__number":"hcr-progress-tracker__number-1-6-0","hcr-progress-tracker__text":"hcr-progress-tracker__text-1-6-0"}};

var bem = Bem('progress-tracker', styles);
var ProgressTracker = function ProgressTracker(_ref) {
  var steps = _ref.steps,
      linked = _ref.linked,
      extraClasses = _ref.extraClasses;
  var Wrap = linked ? 'section' : 'ul';
  var Item = linked ? 'a' : 'li';
  return React.createElement(Wrap, {
    className: bem.b(false, extraClasses)
  }, steps.map(function (_ref2, i) {
    var text = _ref2.text,
        active = _ref2.active,
        rest = _objectWithoutProperties(_ref2, ["text", "active"]);

    return React.createElement(Item, _extends({
      className: bem.e('item', {
        active: active
      }),
      key: text
    }, rest), React.createElement("span", {
      className: bem.e('number')
    }, "".concat(i + 1)), React.createElement("span", {
      className: bem.e('text')
    }, text));
  }));
};
ProgressTracker.displayName = 'ProgressTracker';
ProgressTracker.defaultProps = {
  linked: false,
  extraClasses: ''
};
ProgressTracker.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Steps to be displayed */
  steps: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    active: PropTypes.bool
  })).isRequired,

  /** Display steps as anchors */
  linked: PropTypes.bool
};
var progressTracker = Injecss(ProgressTracker, styles);

export { progressTracker as ProgressTracker };
